import { useState, useEffect } from 'react';
import NavBar from '../Common/NavBar/NavBar';
import SideBar from '../Common/SideBar/SideBar';
import Grid from '../Common/Grid/Grid';
import { getAllParts, updatePartPoint } from '../../Network/Network';
import { toastError, toastSuccess } from '../../Helpers/toasters';
import { Button, Modal, Form, InputNumber } from 'antd';

function Parts() {
  const [tableLoading, setTableLoading] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [allDataSource, setAllDataSource] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingPart, setEditingPart] = useState(null);
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchParts();
  }, []);

  useEffect(() => {
    if (!searchValue) {
      setDataSource(allDataSource);
      return;
    }
    const filtered = allDataSource.filter(
      (item) =>
        item.nameAr?.toLowerCase().includes(searchValue.toLowerCase()) ||
        item.nameEn?.toLowerCase().includes(searchValue.toLowerCase())
    );
    setDataSource(filtered);
  }, [searchValue, allDataSource]);

  const fetchParts = () => {
    setTableLoading(true);
    getAllParts(
      (success) => {
        if (success?.isSuccess) {
          setDataSource(success.data);
          setAllDataSource(success.data);
        } else {
          toastError('فشل تحميل الأجزاء');
        }
        setTableLoading(false);
      },
      () => {
        toastError('حدث خطأ أثناء تحميل الأجزاء');
        setTableLoading(false);
      }
    );
  };

  const openEditModal = (record) => {
    setEditingPart(record);
    form.setFieldsValue({ point: record.point });
    setIsEditModalOpen(true);
  };

  const handleUpdatePoint = (values) => {
    setSaving(true);
    updatePartPoint(
      {
        partId: editingPart._id,
        point: values.point
      },
      (res) => {
        setSaving(false);
        if (res?.isSuccess) {
          toastSuccess('تم تحديث النقاط بنجاح');
          setIsEditModalOpen(false);
          setEditingPart(null);
          form.resetFields();
          fetchParts();
        } else {
          toastError(res?.message || 'فشل في تحديث النقاط');
        }
      },
      () => {
        setSaving(false);
        toastError('حدث خطأ أثناء تحديث النقاط');
      }
    );
  };

  const columns = [
    {
      title: 'الاسم بالعربية',
      dataIndex: 'nameAr',
      key: 'nameAr',
      sorter: (a, b) => a.nameAr?.localeCompare(b.nameAr)
    },
    {
      title: 'الاسم بالإنجليزية',
      dataIndex: 'nameEn',
      key: 'nameEn',
      sorter: (a, b) => a.nameEn?.localeCompare(b.nameEn)
    },
    {
      title: 'النقاط',
      dataIndex: 'point',
      key: 'point',
      sorter: (a, b) => a.point - b.point
    },
    {
      title: 'الإجراءات',
      key: 'action',
      render: (_, record) => (
        <Button type="link" onClick={() => openEditModal(record)}>
          تعديل النقاط
        </Button>
      )
    }
  ];

  return (
    <div className="d-flex">
      <SideBar parent={'parts'} />
      <div className="flex-1 section">
        <NavBar
          getSearchedValue={(value) => {
            setSearchValue(value);
          }}
        />

        <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: 10 }}>
          الأجزاء
        </h2>

        <Grid
          columns={columns}
          dataSource={dataSource}
          loading={tableLoading}
          rowKey={'_id'}
          options={true}
          exportMe={false}
          emptyTableText={{
            emptyText: 'لا توجد أجزاء'
          }}
        />

        <Modal
          title={
            <div style={{ textAlign: 'right', fontWeight: 'bold' }}>
              تعديل نقاط {editingPart?.nameAr || ''}
            </div>
          }
          visible={isEditModalOpen}
          onCancel={() => {
            setIsEditModalOpen(false);
            setEditingPart(null);
            form.resetFields();
          }}
          footer={null}
          destroyOnClose
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleUpdatePoint}
            style={{ direction: 'rtl', textAlign: 'right' }}
          >
            <Form.Item
              name="point"
              label="النقاط"
              rules={[{ required: true, message: 'يرجى إدخال النقاط' }]}
            >
              <InputNumber min={0} style={{ width: '100%' }} placeholder="أدخل النقاط" />
            </Form.Item>

            <Button type="primary" htmlType="submit" block loading={saving}>
              حفظ
            </Button>
          </Form>
        </Modal>
      </div>
    </div>
  );
}

export default Parts;
